<template>
  <app-card elevated tag="section">
    <div class="p-8">
      <header>
        <slot name="header">
          <p v-if="suptitle" class="text-sm text-subtle">
            {{ suptitle }}
          </p>
          <h3 class="text-2xl font-extrabold">
            <slot name="title">
              {{ title }}
            </slot>
          </h3>

          <div v-if="subtitle || $slots.subtitle" class="mt-1">
            <slot name="subtitle">
              <p class="text-subtle">
                {{ subtitle }}
              </p>
            </slot>
          </div>
        </slot>
      </header>

      <div v-if="$slots.default" class="mt-8">
        <slot />
      </div>

      <div v-if="$slots.footer" class="pt-8">
        <slot name="footer" />
      </div>
    </div>

    <slot name="aside-bottom" />
  </app-card>
</template>

<script lang="ts" setup>
import type { I18nMessage } from "@pollen/core/model/i18n.model";

defineProps<{
  title?: I18nMessage;
  subtitle?: I18nMessage;
  suptitle?: I18nMessage;
}>();
</script>
